import { gql } from '@apollo/client'

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginData!) {
    login(input: $input) {
      nextStep
      expiresIn
    }
  }
`

export const UPDATE_USER_PHONE_NUMBER_MUTATION = gql`
  mutation UpdateUserPhoneNumber($input: UpdateUserPhoneNumberInput!) {
    updateUserPhoneNumber(input: $input) {
      expiresIn
    }
  }
`

export const VERIFY_TWO_FA_MUTATION = gql`
  mutation VerifyTwoFA($input: VerifyTwoFAInput!) {
    verifyTwoFA(input: $input) {
      message
    }
  }
`

export const RESEND_OTP_MUTATION = gql`
  mutation ResendOTP {
    resendOTP {
      expiresIn
    }
  }
`

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout {
      message
    }
  }
`

export const LOGIN_HISTORIES_QUERY = gql`
  query LoginHistories($successCount: Int!, $failedCount: Int!) {
    loginHistories(successCount: $successCount, failedCount: $failedCount) {
      ip
      status
      time
    }
  }
`

export const ME_QUERY = gql`
  query Me {
    me {
      name
      email
      accessToken
      refreshToken
      entityName
      entityType
      entityCode
      entityId
      role
      regionalSettings {
        languagesAvailable
        currenciesAvailable
        defaultCurrency
        timezone
      }
      features {
        featureId
        name
        featureGroup
        description
      }
    }
  }
`
